import React from 'react';
import { NavBar } from '../../components/NavBar';
import { Footer } from '../../components/Footer';
import "./contact.css"
const Contact = () => {
  return (
    <>
    <NavBar/>
      <div className="bg-info contact4 p-5 overflow-hiddedn position-relative">
        <div className="row no-gutters">
          <div className="container">
            <div className="col-lg-12 contact-box mb-4 mb-md-0">
              <div className="row">
                <div className='form-wrapper'>
                  <h2>İLETİŞİM</h2>
                  <div className="map-container">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3128.005332550436!2d27.18563005095781!3d38.371998085246545!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14b961ffb5938b59%3A0x4314ba7e4c1e4d23!2sSushi%20Vibe!5e0!3m2!1sen!2str!4v1674475734369!5m2!1sen!2str"
                      className="responsive-map"
                      allowFullScreen 
                      data-aos="fade-left" 
                      loading="lazy" 
                      referrerPolicy="no-referrer-when-downgrade"
                      data-aos-duration="3000"
                    />
                  </div>         
                  <div className="contact-details-grid mt-5">
                    <div className="row g-4">
                      {/* Phone Section */}
                      <div className="col-md-6">
                        <div className="contact-item-card">
                          <div className="icon-wrapper phone-bg">
                            <i className="fas fa-phone"></i>
                          </div>
                          <div className="contact-text">
                            <label className="contact-label">Bize Ulaşın</label>
                            <a href="tel:+905524944813" className="contact-link">
                              +90 552 494 4813
                            </a>
                          </div>
                        </div>
                      </div>

                      {/* Email Section */}
                      <div className="col-md-6">
                        <div className="contact-item-card">
                          <div className="icon-wrapper email-bg">
                            <i className="fas fa-envelope"></i>
                          </div>
                          <div className="contact-text">
                            <label className="contact-label">E-posta Gönderin</label>
                            <a href="mailto:Usa.vibe7@gmail.com" className="contact-link">
                              Usa.vibe7@gmail.com
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Social Media Section */}
                    <div className="social-media-container mt-5 text-center">
                      <h5 className="social-title">Sosyal Medyada Biz</h5>
                      <div className="d-flex justify-content-center gap-4 mt-3">
                        {/* Facebook */}
                        <a 
                          href="https://facebook.com/sushivibe" 
                          target="_blank" 
                          rel="noopener noreferrer" 
                          className="social-btn facebook"
                        >
                          <i className="fab fa-facebook-f"></i>
                        </a>

                        {/* Instagram */}
                        <a 
                          href="https://instagram.com/sushivibe" 
                          target="_blank" 
                          rel="noopener noreferrer" 
                          className="social-btn instagram"
                        >
                          <i className="fab fa-instagram"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
              </div>
            </div>
          </div>
      </div>
    <Footer/>
    </>
  )
}

export default Contact;
